import { useEffect } from 'react';
import Lenis from 'lenis';

//  now the scroll start fast then midium then at end slow 
const lenisEasing = (t) => 1 - Math.pow(1 - t, 3);

const useLenis = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let lenisInstance;
    let rafId;
    let dialogOpen = false;
    let previousHtmlOverflow = '';


    // only change this for the smomthness of the scroll no need to change hole code 
    const startLenis = () => {
      lenisInstance = new Lenis({
        lerp: 0.20,             // Lerp = how quickly the page "catches up" to your scroll. Low value (0.04) = very stretchy band = heavy, luxury drag. High value (0.15) = stiff band = snappy, almost instant.
        smoothWheel: true,      // always use true for smooth scrolling. if we use false then mouse scroll wheel will work normally
        wheelMultiplier: 0.6,   // How fast the page travels per single mouse wheel tick (single scroll). 0.6 = each tick moves the page less → makes the inertia feel more dramatic. 1.0 = normal distance. 2.0 = rockets.
        touchMultiplier: 1.2,   // it was not necessary now. it use for touch devies ( monile , touchable laptop ). it use when user scroll with fingure ( Same as wheelMultiplier ) 0.5 = slow scroll speed. 1.0 = normal scroll speed. 2.0 = fats scroll speed.
        easing: lenisEasing,    // function that are used for the smooth scroll  ( line number 5 )
        infinite: false,        // if we use false then the smooth scroll will work both time scroll up and down but when use true then it work only don side not up side 
      });

      // Opened before Lenis existed (e.g. reduced-motion toggled): respect the open dialog.
      if (dialogOpen) lenisInstance.stop();

      const raf = (time) => {
        lenisInstance?.raf(time);
        rafId = window.requestAnimationFrame(raf);
      };

      rafId = window.requestAnimationFrame(raf);
    };

    const stopLenis = () => {
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = undefined; }
      if (lenisInstance) { lenisInstance.destroy(); lenisInstance = undefined; }
    };

    // While a modal dialog is open (e.g. Aithoris preferences or data-rights form; the non-modal
    // consent banner is excluded), the page behind
    // must not scroll: stop Lenis and lock the document. The dialog's own scroll area still
    // scrolls natively because it is not the document root.
    const syncDialogLock = () => {
      const open = !!document.querySelector('[aria-modal="true"]:not([aria-label="Consent banner"])');
      if (open === dialogOpen) return;
      dialogOpen = open;
      if (open) {
        previousHtmlOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        lenisInstance?.stop();
      } else {
        document.documentElement.style.overflow = previousHtmlOverflow;
        lenisInstance?.start();
      }
    };

    const handleReducedMotionChange = (event) => {
      if (event.matches) stopLenis();
      else if (!lenisInstance) startLenis();
    };

    const observer = new MutationObserver(syncDialogLock);
    observer.observe(document.body, { childList: true, subtree: true });
    syncDialogLock();

    if (!reducedMotionQuery.matches) startLenis();

    reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
    return () => {
      observer.disconnect();
      if (dialogOpen) document.documentElement.style.overflow = previousHtmlOverflow;
      dialogOpen = false;
      reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);
      stopLenis();
    };
  }, []);
};

export default useLenis;